<template>
    <div>
        <b-row class="footer m-0">
                <!--=====================================
                ACERCA DEL FRACCIONAMIENTO
                ======================================-->
                <b-container>
                    <b-row>
                        <b-col class="text-center" cols="12" md="4">
                            <h4>Acerca de nosotros</h4>
                            <p>
                                Página de acercamiento entre la asociación y el fraccionamiento, todas las secciones diseñadas para llevar la información necesaria entre la mesa directiva y los colonos del fraccionamiento.
                            </p>
                            <h4>Siguenos en</h4>
                            <ul class="list-inline">
                                <li v-show="facebook != '#'">
                                    <a :href='facebook' target='_blank'> <b-icon-facebook></b-icon-facebook> </a>
                                </li>
                                <li v-show="google != '#'">
                                    <a :href='google' target='_blank'> <b-icon-youtube></b-icon-youtube>
                                    </a>
                                </li>
                                <li v-show="twitter != '#'">
                                    <a :href='twitter' target='_blank'> <b-icon-twitter></b-icon-twitter>
                                    </a>
                                </li>
                                <li v-show="linkedin != '#'">
                                    <a :href='linkedin' target='_blank'> <b-icon-linkedin></b-icon-linkedin>
                                    </a>
                                </li>
                    
                            </ul>
                        </b-col>
                        <!--=====================================
                        MAPA DE UBICACIÓN
                        ======================================-->
                        <b-col cols="12" md="4">
                            <h4 class="text-center">Encuentranos</h4>
                    
                            <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d14998.131294285078!2d-103.77492305082485!3d19.98614002269272!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTnCsDU5JzEwLjEiTiAxMDPCsDQ1JzUyLjYiVw!5e0!3m2!1ses!2smx!4v1773167636803!5m2!1ses!2smx" width="100%" height="200" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </b-col>
                        <!--=====================================
                        SECCION DE CONTACTÓ
                        ======================================-->
                        <b-col class="text-center" cols="12" md="4">
                            <h4>Contactanos</h4>
                            <ul class="list-unstyled">
                                <li>{{ params.direccion }}</li>
                                <li>{{ params.direccion2 }}</li>
                                <li><b-icon-telephone-fill></b-icon-telephone-fill> Teléfono: {{ params.telefono }}</li>
                                <li><b-icon-envelope-open-fill></b-icon-envelope-open-fill> Email: <span><a href="mailto:">{{ params.email_contacto }}</a></span>
                                </li>
                            </ul>
                        </b-col>
                    </b-row>

                </b-container>
        </b-row>
        <b-row class="copyright m-0">
            <b-container>
                <p>©2015 -  Sistemas y Mapas Digitales S.A. de C.V.</p>
            </b-container>
        </b-row>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import axios from 'axios'

export default {
    name: 'Nombre',
    props: {
    },
    data() {
        return {
            params: '',
            facebook: '#',
            google: '#',
            twitter: '#',
            linkedin: '#'
        }
    },
    created() {
        this.traerParametros()
    },
    methods: {
        refrescar() {
            this.traerParametros()
        },
        traerParametros() {
            var formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "parametros");
            formData.append("limite", 1);
            
            axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                if (res.data) {
                    this.params = res.data

                    if (res.data.facebook != null && res.data.facebook != '') {
                        this.facebook = res.data.facebook
                    }
                    if (res.data.google_plus != null  && res.data.google_plus != '') {
                        this.google = res.data.google_plus
                    }
                    if (res.data.twitter != null  && res.data.twitter != '') {
                        this.twitter = res.data.twitter
                    }
                    if (res.data.linkedin != null  && res.data.linkedin != '') {
                        this.linkedin = res.data.linkedin
                    }
                }
            });
        }
    },
    computed: {
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>

<style scoped>
@import '../../../assets/css/bootstrap-custom.css';

.footer {
    /* position: absolute;
    bottom: 49px;
    left: 0;
    right: 0; */

    background-color: var(--theme-primary);
    color: #ddd;
    padding: 30px 0px;

    overflow-x: hidden;
}

.footer h4 {
    color: #fff;
}

.footer a {
    color: #ddd;
}

.footer img {
    width: 50px;
}

.footer .btn-primary.text-white {
    margin-top: 2%;
}

.list-inline li {
    display: inline-block;
    padding: 0 5px;
}

.copyright {
    /* position: absolute;
    bottom: 0;
    left: 0;
    right: 0; */

    background-color: var(--theme-secondary);
    color: #ddd;
    padding-top: 10px;
}
</style>